<script>
  import ClientsSection from "../sections/ClientsSection.svelte";
  import LiveDemoSection from "../sections/LiveDemoSection.svelte";
  import PricingPlansSection from "../sections/PricingPlansSection.svelte";
  import CurbzaEnterprizeSection from "../sections/CurbzaEnterpriseSection.svelte";
  import WhyCurbzaSection from "../sections/WhyCurbzaSection.svelte";
  import CaseStudiesSection from "../sections/CaseStudiesSection.svelte";
  import AboutSection from "../sections/AboutSection.svelte";
  import { createEventDispatcher } from 'svelte';
  import HeroSection from "../sections/HeroSection.svelte";

  const dispatch = createEventDispatcher();

  const onPlanSelect = (e) => {
    const event = new CustomEvent('planselect', {
      detail: e.detail
    });

    document.dispatchEvent(event);
  }

  const onLiveDemo = (e) => {
    dispatch('livedemo', e);
  };
</script>

<style>
  main {
    margin: 0;
    padding: 0;
    position: relative;
  }

  @media (min-width: 640px) {
  }
</style>

<main>
    <!-- Hero -->
    <HeroSection />

    <!-- Clients -->
    <ClientsSection
      title="Clients" />

    <!-- Why Curbza -->
    <WhyCurbzaSection />

    <!-- Live Demo -->
    <!-- <LiveDemoSection on:livedemo={onLiveDemo} /> -->

    <!-- Case Studies -->
    <!-- <CaseStudiesSection /> -->

    <!-- Curbza Enterprise -->
    <CurbzaEnterprizeSection />

    <!-- Pricing Plans -->
    <PricingPlansSection on:select={onPlanSelect} />

    <!-- About Us -->
    <AboutSection />
</main>
